import React from 'react';
import styled from 'styled-components';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';

import {
  InfoTextBox,
  SkypassFooterSubNoticeContainer,
  TextBold,
} from '@ecp/mo/sites/skypass/styles/footer/SkypassFooterNoticeStyles';

export default function SkypassFooterNotice() {
  return (
    <Container>
      <FlexBoxColumn align-items={'flex-start'}>
        <Spacing top={'30px'} />
        <InfoTextBox size={'16px'} weight={'bold'} height={'28px'}>
          이벤트 유의사항
        </InfoTextBox>
        <Spacing top={'4px'} />
        <SkypassFooterSubNoticeContainer>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>이벤트 기간 : 2026년 10월 1일 (목) ~ 2026년 10월 31일 (토)
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>본 이벤트는 마일리지 몰 쇼핑에서 마일리지를 사용하고, 쇼핑 이벤트에
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold></TextBold> 응모한 고객을 대상으로 합니다.
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>대한항공 SKYPASS에 등록된 개인정보를 기준으로 경품 지급이 안내
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold> </TextBold>됩니다.
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>잘못된 개인정보로 인한 발송 오류 시 재발송이 불가하오니, 사전에 개인
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold> </TextBold>정보를 확인해주시기 바랍니다.
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>모든 경품은 명의 변경, 유효기간 연장, 교환 및 환불이 불가하며, 경품
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold> </TextBold>내용 및 당첨 인원은 사전 고지 없이 변경 될 수 있습니다.
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>본 이벤트에 참여하실 경우 개인정보 제공에 동의하신 것으로 간주되며,
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold> </TextBold>발송을 위해 제공된 정보는 발송 후 60일 이내 폐기됩니다.
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold> </TextBold>(개인정보 위탁업체: (주)케이티알파 / 제공 개인정보 범위: 휴대전화번호)
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>해당 경품은 업체 사정에 따라 동일 스펙의 다른 상품으로 변경될 수 있습
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold> </TextBold>발송을 위해 제공된 정보는 발송 후 60일 이내 폐기됩니다.
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>당첨자 발표(항공권) : 2026년 11월 11일 (수) 대한항공 홈페이지
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>당첨자 발표(배달의민족 및 다이소 상품권) : 2026년 11월 11일 (수)
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold> </TextBold>홈페이지 공지 없이 당첨자 대상 경품 발송 문자로 개별 안내
          </InfoTextBox>
          <br/>
          <InfoTextBox size={'14px'} weight={'bold'} height={'28px'}>
            [이벤트 1]
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>혜택① : 1회 이상 구매한 고객 중 추첨을 통해 푸켓 일반석 왕복 항공권
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold> </TextBold>2매 증정
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>혜택② : 1만/3만 마일 이상 구매한 고객별 추첨을 통해 배달의민족 상품
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold> </TextBold>권 2만/5만원권 증정
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>혜택 ①, ②는 중복 당첨 가능합니다.
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>항공권 경품 집행을 위해 당첨자의 개인정보(이름, 연락처)가 (주)한진트
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold> </TextBold>래블에 제공되며, 항공권 발권 시 유류할증료 및 공항세 등 당첨자 본인 부
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold> </TextBold>담금이 발생할 수 있습니다.
          </InfoTextBox>
          <br/>
          <InfoTextBox size={'14px'} weight={'bold'} height={'28px'}>
            [이벤트 2]
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>혜택 : 이벤트 기간 중 올해 처음 상품을 구매한 고객 중 추첨을 통해 다이
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold> </TextBold>소 상품권 5천원권 증정
          </InfoTextBox>
        </SkypassFooterSubNoticeContainer>
      </FlexBoxColumn>
    </Container>
  );
}

const Container = styled(FlexBoxColumn)`
  background-color: ${(props) => props.theme.color.background.basic};
  align-items: flex-start;
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;
  height: 670px;
`;
